import { pieColors, yesNoMapper, genderMapper } from '../dashHelper'
import { generateChartColors } from 'utils/chartColor.util'


export const widgetsPies: CommonWidget = {

  /**************************************************************************
   *                                PIES
  ***************************************************************************/

  donutCenter: {
    title: 'FALTA',
    position: [0, 0],
    size: [1, 2],
    config: {
      id: 'donut-center',
      type: 'donutCenter',
      showValues: true,
      showLegend: false,
      decimals: 0,
      radius: ['60%', '80%'],
      center: ['50%', '50%'],
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['value', 'count'],
          value: 'value',
          singleton: false,
        },
      ],
    },
  },

  pieGenericSmall: {
    title: 'FALTA',
    // [Column, Row]
    position: [0, 44],
    // [width, height]
    size: [1, 2],
    config: {
      id: 'pie-generic-small',
      type: 'pie',
      //colors: pieColors,
      //evita colores repetidos
      colors: generateChartColors(
        pieColors,
        20
      ),
      radius: [40, 85],
      center: ['40%', '55%'],
      showValues: true,
      showSample: true,
      decimals: 2,
      legendTop: 'center',
      legendOrient: 'vertical',
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['group', 'count', 'value', 'groupName'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },
  pieGenericMedium: {
    title: 'FALTA',
    // [Column, Row]
    position: [2, 44],
    size: [2, 2],
    config: {
      id: 'pie-generic-medium',
      type: 'pie',
      fillMode: '',
      //colors: pieColors,
      //evita colores repetidos
      colors: generateChartColors(
        pieColors,
        20
      ),
      showValues: true,
      showSample: false,
      //mapper: groupMapperLateral,
      itemWidth: 80,
      itemHeight: 20,
      //valueFormat: ' >-.1%',
      arcLabelsRadiusOffset: 1.15,
      itemDirection: 'left-to-right',
      anchor: 'top-left',
      direction: 'column',
      marginLeft: 250,
      decimals: 2,
      legendTranslateX: -200,
      radius: [40, 85],
      center: ['40%', '55%'],
      indicators: [
        {
          indicator: 'FALTA',
          //grouped: 'geoLocation',
          keyExtract: ['group', 'count', 'value', 'groupId'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },
  pieGenericLarge: {
    title: 'FALTA',
    // [Column, Row]
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'pie-generic-large',
      type: 'pie',
      fillMode: '',
      colors: pieColors,
      showValues: true,
      showSample: false,
      itemWidth: 80,
      itemHeight: 20,
      itemGap: 17,
      //valueFormat: ' >-.1%',
      arcLabelsRadiusOffset: 1.15,
      itemDirection: 'left-to-right',
      anchor: 'top-left',
      direction: 'column',
      center: ['29%', '55%'],
      radius: [40, 95],
      decimals: 2,
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['group', 'count', 'value'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },
  pieSiNo: {
    title: '',
    position: [0, 0],
    size: [1, 2],
    config: {
      id: 'pie-si-no',
      type: 'pie',
      colors: pieColors,
      radius: [40, 85],
      center: ['40%', '55%'],
      showValues: true,
      showSample: false,
      decimals: 2,
      legendTop: 'bottom',
      legendOrient: 'vertical',
      mapper: yesNoMapper,
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['group', 'count', 'value', 'groupName'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },
  pieGender: {
     title: '',
     position: [0, 0],
     size: [1, 2],
     config: {
       id: 'pie-gender',
       type: 'pie',
       colors: pieColors,
       radius: [40, 85],
       center: ['40%', '55%'],
       showValues: true,
       showSample: false,
       decimals: 2,
       legendTop: 'bottom',
       legendOrient: 'vertical',
       mapper: genderMapper,
       indicators: [
         {
           indicator: 'FALTA',
           keyExtract: ['group', 'count', 'value', 'groupName'],
           label: 'group',
           value: 'value',
           singleton: true,
           extras: {
             groupNameFormat: 'description',
           },
         },
       ],
     },
   },


 alertPieNationalFull: {
    title: 'Alertas vs Total porcentual',
    helpLink: '--',
    position: [0, 36],
    size: [2, 2], // Los pasteles suelen ser más cuadrados
    config: {
      id: 'alert-pie-national-full',
      type: 'pie',
      showValues: true,
      showLegend: true,
      fillMode: 'solid',
      // Tomamos la configuración de estilo del genérico que nos pasaste:
      arcLabelsRadiusOffset: 1.15,
      itemDirection: 'left-to-right',
      
      mapper: (data: any, extra: any) => {
      console.log('🔥 Data cruda del Pastel:', data);

      let totalWow = 0;
      let totalRescue = 0;
      let totalEncuestas = 0;

      // 1. Sumamos TODAS las encuestas
      const totalData = data['total-data'] || [];
      totalData.forEach((item: any) => {
        totalEncuestas += Math.round(Number(item.count || item.value || 0));
      });

      // 2. Sumamos TODAS las alertas
      const alertData = data['alert-data'] || [];
      alertData.forEach((item: any) => {
        const pos = item['value.positiveCount'] || item?.value?.positiveCount || 0;
        const neg = item['value.negativeCount'] || item?.value?.negativeCount || 0;
        totalWow += Math.round(Number(pos));
        totalRescue += Math.round(Number(neg));
      });

      // 3. 🧮 HAGAMOS MATEMÁTICAS (Calculamos porcentajes a 1 decimal)
      let wowPerc = 0;
      let rescuePerc = 0;
      let noDetonadasPerc = 0;

      // Protegemos contra divisiones entre cero por si no hay encuestas
      if (totalEncuestas > 0) {
        wowPerc = Number(((totalWow / totalEncuestas) * 100).toFixed(1));
        rescuePerc = Number(((totalRescue / totalEncuestas) * 100).toFixed(1));
        
        // El resto se lo asignamos a "Sin Alerta" para que siempre sume 100% clavado
        noDetonadasPerc = Number((100 - wowPerc - rescuePerc).toFixed(1));
        
        // Pequeña red de seguridad por si las alertas fueran más que el total (bugs de la API)
        if (noDetonadasPerc < 0) noDetonadasPerc = 0; 
      }

      const noDetonadasCount = Math.max(0, totalEncuestas - totalWow - totalRescue);

      // 4. Servimos las 3 rebanadas con porcentaje y conteo absoluto
      const finalPie = [
        { id: 'noDetonated', label: 'Sin Alerta', value: noDetonadasPerc, count: noDetonadasCount },
        { id: 'wow', label: 'WOW', value: wowPerc, count: totalWow },
        { id: 'rescue', label: 'Rescate', value: rescuePerc, count: totalRescue }
      ];

      console.log('🥧 Pastel listo para servir (en %):', finalPie);
      return finalPie;
    },

      indicators: [
        {
          key: 'alert-data',
          indicator: 'alert-counters',
          // Ya no agrupamos por semana, queremos el bulto total.
          // Si el endpoint te obliga a agrupar, déjale 'formattedWeek', el mapper lo sumará todo igual.
          keyExtract: ['value.totalCount', 'value.positiveCount', 'value.negativeCount'],
          singleton: true,
          extras: { periods: 8 }
        },
        {
          key: 'total-data', 
          indicator: 'satisfaction',
          keyExtract: ['count', 'value'],
          singleton: true,
          extras: { periods: 8 }
        }
      ]  
    }
  }


}
